package com.evoapps.evoshift.settings

import com.evoapps.evoshift.domain.model.Appearance
import com.evoapps.evoshift.ui.AppAppearance
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * SH-196: the app's colours (base and accent) picked in Profile → Appearance. Remembered on this
 * device, so the app starts in them at once (also signed out, before the profile answers); the
 * profile keeps them too (users/{uid}.appearance, ProfileAppearanceSync), so another device of the
 * same person follows after signing in. Created once per app (DI singleton): creating it applies
 * the remembered colours.
 */
class ThemeSettings(private val store: LocalSettings) {
    private val _appearance = MutableStateFlow(Appearance.fromStored(store.getString(KEY)))

    /** The appearance on show, as a flow (view models). */
    val appearance: StateFlow<Appearance> = _appearance.asStateFlow()

    init {
        AppAppearance.current = _appearance.value
    }

    /** The appearance on show. */
    val current: Appearance get() = _appearance.value

    /** Shows [appearance] at once and remembers it on this device. */
    fun choose(appearance: Appearance) {
        store.putString(KEY, appearance.takeIf { it != Appearance.DEFAULT }?.stored)
        _appearance.value = appearance
        AppAppearance.current = appearance
    }

    companion object {
        const val KEY = "appAppearance"
    }
}
